module.exports = __webpack_public_path__ + "img/2012-08-18 17.18.29.e5d28dfc.jpg";